export default __webpack_public_path__ + "static/applet-20-set-1-f9ac90705ae18ea5f23b3d09f9854ab4.webp";